export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13606.785fe605.jpg";